export type MapQueryComparator = ">" | ">=" | "<" | "<=" | "=" | "!=";

export const MAP_QUERY_COMPARATORS: MapQueryComparator[] = [">", ">=", "<", "<=", "=", "!="];

function compare(value: number, comparator: MapQueryComparator, threshold: number): boolean {
  switch (comparator) {
    case ">":
      return value > threshold;
    case ">=":
      return value >= threshold;
    case "<":
      return value < threshold;
    case "<=":
      return value <= threshold;
    case "=":
      return value === threshold;
    case "!=":
      return value !== threshold;
  }
}

export function findMapQueryMatches(
  values: Map<string, number>,
  comparator: MapQueryComparator,
  threshold: number
): Set<string> {
  const matches = new Set<string>();
  for (const [name, v] of values) {
    if (compare(v, comparator, threshold)) matches.add(name);
  }
  return matches;
}
